var _rect, _path, _path2, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDragImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 42,
    viewBox: "0 0 120 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 119,
    height: 41,
    rx: 7.5,
    fill: "#E9F6F5",
    stroke: "#95D7CE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H21.4286V42H8C3.58172 42 0 38.4183 0 34V8Z",
    fill: "#95D7CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.85713 17.6C7.06815 17.6 6.42856 17.018 6.42856 16.3C6.42856 15.582 7.06815 15 7.85713 15C8.64611 15 9.2857 15.582 9.2857 16.3C9.2857 17.018 8.64611 17.6 7.85713 17.6ZM7.85713 22.8C7.06815 22.8 6.42856 22.218 6.42856 21.5C6.42856 20.782 7.06815 20.2 7.85713 20.2C8.64611 20.2 9.2857 20.782 9.2857 21.5C9.2857 22.218 8.64611 22.8 7.85713 22.8ZM7.85713 28C7.06815 28 6.42856 27.418 6.42856 26.7C6.42856 25.982 7.06815 25.4 7.85713 25.4C8.64611 25.4 9.2857 25.982 9.2857 26.7C9.2857 27.418 8.64611 28 7.85713 28ZM13.5714 17.6C12.7824 17.6 12.1428 17.018 12.1428 16.3C12.1428 15.582 12.7824 15 13.5714 15C14.3604 15 15 15.582 15 16.3C15 17.018 14.3604 17.6 13.5714 17.6ZM13.5714 22.8C12.7824 22.8 12.1428 22.218 12.1428 21.5C12.1428 20.782 12.7824 20.2 13.5714 20.2C14.3604 20.2 15 20.782 15 21.5C15 22.218 14.3604 22.8 13.5714 22.8ZM13.5714 28C12.7824 28 12.1428 27.418 12.1428 26.7C12.1428 25.982 12.7824 25.4 13.5714 25.4C14.3604 25.4 15 25.982 15 26.7C15 27.418 14.3604 28 13.5714 28Z",
    fill: "#4A7B75"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 11,
    width: 68,
    height: 4,
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 27,
    width: 68,
    height: 4,
    fill: "#D9D9D9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragImage);
export default __webpack_public_path__ + "static/media/drag-image.2bce3237f83c1637f3dab6b25eecbe65.svg";
export { ForwardRef as ReactComponent };